import { Component, EventEmitter, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import * as constant from './../shared/constants/constants';
import { MatTableDataSource } from '@angular/material/table';
import { UtilService } from '../shared/services/util.service';
import { ToastrService } from 'ngx-toastr';
import { ScenerioService } from '../shared/services/scenerio.service';
import { ExceptionService } from '../shared/services/exception.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../shared/services/storage.service';
import { UrlSecurityService } from '../shared/services/url-security.service';
import { ActivatedRoute, Router } from '@angular/router';
import { category_name } from '../core/enum';

@Component({
  selector: 'app-price-hierarchy-popup',
  templateUrl: './price-hierarchy-popup.component.html',
  styleUrls: ['./price-hierarchy-popup.component.scss', './../scenario-sku-level-table/scenario-sku-level-table.component.scss']
})
export class PriceHierarchyPopupComponent implements OnInit  {

  @Input() price_hierarchy_pop_up_settings: any = { open: constant.common.display_none }
  @Output() percenatage_data: any = new EventEmitter()

  /** Price Hierarchy Popup Variables */
  price_hierarchy_table_columns: any = constant.scenario.price_hierarchy_columns;
  price_hierarchy_data : any = []
  price_hierarchy_dataSource: any = new MatTableDataSource()
  save_price_hierarchy_data:any =[]

  /** Percentage Change Variables */
  percentage_change = new Map()
  is_validate_percentage_enable: any = false;

  /** Configuration Variables */
  configuration: any; 
  minPercentageRange : any ;
  maxPercentageRange: any  ;
  pbrSettings : any ;

  /**  */
  category_error = true;
  category_ids:any = [];
  categories_set = new Set();
  category_name_set = new Set();
  error_message = '';

  constructor(private utilService: UtilService, private toastrService: ToastrService, private scenarioService: ScenerioService, private exceptionService : ExceptionService, private translateService: TranslateService, private storageService: StorageService, private urlService: UrlSecurityService, private activatedRoute : ActivatedRoute, private router: Router) {
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.pbrSettings =  JSON.parse(this.urlService.decryptUsingAES256(params.params?.pbrSettings))
    });
    this.scenarioService.price_hierarchy.subscribe((value:any)=>{
      value.isSaved? this.loadPriceHeirarchyData(value.data):   this.handlePriceHierarchyResponse(value.data)
    })
  }

  ngOnInit(): void {
    this.getCofigValuesFromSession()
  }

  ngOnChanges(changes: SimpleChanges) {
    const currentValue = changes['price_hierarchy_pop_up_settings']['currentValue'];
    const categorieIds = currentValue['categorieIds'];
    if (this.hasValidCategoryIds(categorieIds)) {
      this.category_ids = categorieIds;
      this.populateCategorySets();
      this.category_error = this.checkCategoryError();
    } else {
      this.category_error = true;
    }
    this.error_message = this.buildErrorMessage();
    if (!this.category_error) {
      this.error_message += this.translateService.instant(constant.scenario.price_hierarchy_error.general_error);
    }
    if (this.price_hierarchy_data.length > 0) {
      this.setIntialChange();
    }
  }
  
  /** To Check Category We Get From Filter */
  hasValidCategoryIds(categorieIds: any): boolean {
    return categorieIds && categorieIds.length > 0;
  }
  
  /** To Populate Category Id and Name Sets of Price Hierarchy */
  populateCategorySets(): void {
    this.price_hierarchy_data.forEach((data: any) => {
      this.categories_set.add(data?.Food?.sku02);
      this.categories_set.add(data?.Beverages?.sku02);
      if (data?.Food?.sku02) {
        this.category_name_set.add(category_name.food);
      }
      if (data?.Beverages?.sku02) {
        this.category_name_set.add(category_name.beverage);
      }
    });
    this.categories_set.delete(undefined);
  }
  
  /** To Check for Category Error */
  checkCategoryError(): boolean {
    return this.category_ids.some((id: any) => this.categories_set.has(id));
  }
  
  /** Build Error Message to Show */
  buildErrorMessage(): string {
    const hasFood = this.category_name_set.has(category_name.food);
    const hasBeverages = this.category_name_set.has(category_name.beverage);
    
    const foodText = hasFood ? category_name.food : "";
    const beverageText = hasBeverages ? category_name.beverage : "";
    const andText = (hasFood && hasBeverages) ? category_name.and : "";
    
    return this.translateService.instant(constant.scenario.price_hierarchy_error.category_error, {
      food: foodText,
      beverage: beverageText,
      and: andText
    });
  }
  

  /** Save Intial Percentage Change */
  setIntialChange(){
    this.percentage_change.clear();
    this.price_hierarchy_data.forEach((row: any) => {
      const { Food, Beverages, geo_code } = row;
      if (!row.is_base_pb && Food?.sku02 && this.category_ids.includes(Food.sku02)) {
        this.onValidatePercentageChange(Food.value, `${geo_code}:${Food.sku02}`, null);
      }
      if (!row.is_base_pb && Beverages?.sku02 && this.category_ids.includes(Beverages.sku02)) {
        this.onValidatePercentageChange(Beverages.value, `${geo_code}:${Beverages.sku02}`, null);
      }
    });
    
  }


  /** Get Config Values From Session Storage */
  async getCofigValuesFromSession() {
    this.configuration = await this.storageService.get(constant.storage_keys.configuration);
    this.minPercentageRange = this.configuration[constant.configuration_keys.price_hierarchy_range_min];
    this.maxPercentageRange = this.configuration[constant.configuration_keys.price_hierarchy_range_max]
  }

  async loadPriceHeirarchyData(data:any) {
    this.price_hierarchy_data = data;
    this.price_hierarchy_dataSource = new MatTableDataSource(this.price_hierarchy_data);
  }

  /** Handle Response from Price Heirarchy */
  handlePriceHierarchyResponse(response:any) {
    if(response && response.length>0)
    {
      const price_band_item: any = {};
      response.forEach((item: any) => {
        if (!price_band_item[item.geo_code]) {
          price_band_item[item.geo_code] = {
            geo_code: item.geo_code,
            geo_name: item.geo_name,
            is_base_pb: item.is_base_pb,
            category_id: item.sku02
          };
        }
        price_band_item[item.geo_code][item.skun02] = { "sku02": item.sku02, "value": item.value, "originalValue": item.value };
      });
      this.price_hierarchy_data = Object.values(price_band_item);
      this.updateUrlParams();
    }
  }

  /** onChange percentage change event */
  async onValidatePercentageChange(current_percentage: any, id: any, event: any) {
    let newPercentage = event ? event?.target?.value : current_percentage ;
    this.validatePercentageChange( newPercentage, id);
  }

  /** percentage change validation */
  validatePercentageChange( newPercentage: any, itemCode: any) {
    this.addPercentageChangedItem(itemCode, newPercentage);
    this.rangePercentageValidation();
  }

  /** Add Percentage Changed Item in the Map */
  addPercentageChangedItem(itemCode: any, newPercentage: any) {
    this.percentage_change.set(itemCode, this.utilService.validateNumberCheck(newPercentage))
  }

  /** zero validation */
  rangePercentageValidation() {
    this.is_validate_percentage_enable = false;
    for (let entry of this.percentage_change.entries()) {
      const currentPercentageChange = this.percentage_change.get(entry[constant.common.zero]);
      if (currentPercentageChange < this.minPercentageRange || currentPercentageChange > this.maxPercentageRange) {
        this.is_validate_percentage_enable = true;
        this.rangeValidationMessage();
        break;
      }
    }
  }

  /** Zero Validation Message */
  rangeValidationMessage() {
    this.toastrService.warning(this.translateService.instant(constant.translate_text.valid_percentage_error, {min:this.minPercentageRange, max:this.maxPercentageRange}));
  }

  /** get Percentage updated Details */
  getPercentageChangeDetails(obj: any) {
    return !this.utilService.isNullOrEmptyOrUndefined(this.percentage_change.get(obj.id)) ?
      this.percentage_change.get(obj.id) : this.utilService.validateNumberCheck(obj.percentage);
  }

  /** Save Price Hierarchy Details on Yes Button CLick  */
  savePriceHeirarchyDetails() {
    this.updateUrlParams();
    this.percenatage_data.emit(this.percentageChangeDetailsforRecalculate())
    this.closePopup();
    this.percentage_change.clear();
  }

  /** Close Price Hierarchy Popup */
  closePopup() {
    this.price_hierarchy_pop_up_settings.open = constant.common.display_none;
  }

  /** Only Numbers */
  onlyNumberKey(event: any) {
    var charCode = (event.which) ? event.which : event.keyCode

    if ((charCode < 48 || charCode > 57) && charCode != 8 && charCode != 44 && charCode != 46) {
      return false;
    }
    return true;
  }

  /** Function for Data to send for recalculate on Percentage Change Details */
  percentageChangeDetailsforRecalculate() {
    return Array.from(this.percentage_change.entries()).map(([key, value]) => {
      let [geo_code, sku02] = key.split(':');
      geo_code = parseInt(geo_code)
      return {
        geo_code,
        sku02,
        value: this.percentage_change.get(key)
      };
    });
  }

  /** Update URL Params Based on PriceHierarchy Data */
  updateUrlParams(): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {pbrSettings: this.urlService.encryptUsingAES256(JSON.stringify({...this.pbrSettings, price_hierarchy_data: this.price_hierarchy_data}))},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
}

